import { types as t } from 'mobx-state-tree';

import { Translation } from 'models/ui';

export const Department = t.model('Department', {
  id: t.number,
  externalId: t.maybeNull(t.string),
  translations: t.array(Translation),
});
